import { render, staticRenderFns } from "./SchemeQrcode.vue?vue&type=template&id=2f4b9b6a&scoped=true&"
import script from "./SchemeQrcode.vue?vue&type=script&lang=js&"
export * from "./SchemeQrcode.vue?vue&type=script&lang=js&"
import style0 from "./SchemeQrcode.vue?vue&type=style&index=0&id=2f4b9b6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b9b6a",
  null
  
)

export default component.exports